import { Roles, Country } from '@shs-digi-care-monorepo/interfaces';
import { EmeaFeature, FeatureConfig } from './emea-feature.model';

/**
 * Role presets
 */
/** Stream-level EMEA admin only. */
export const ADMIN = [Roles.ADMIN];

/** Stream admin plus zone e-commerce stewards, who administer a set of countries. */
export const ZONE_ADMIN = [Roles.ADMIN, Roles.ZONE_E_COMMERCE_STEWARD];

/** Every role with administrative permissions, down to the key country user. */
export const COUNTRY_ADMIN = [Roles.ADMIN, Roles.ZONE_E_COMMERCE_STEWARD, Roles.KEY_COUNTRY_USER];

/** Roles that work on tasks. */
export const TASK_OWNER_AND_ABOVE = [...COUNTRY_ADMIN, Roles.TASK_OWNER];

/**
 * Central feature configuration map.
 * Each entry defines the countries (and optionally roles/stages) for which a feature is enabled.
 *
 * To add a new country-gated feature:
 * 1. Add an entry to the `EmeaFeature` enum
 * 2. Add the corresponding config here
 * 3. Use `EmeaFeatureService.isEnabled(EmeaFeature.YOUR_FEATURE)` in components
 */
export const FEATURE_CONFIG: Record<EmeaFeature, FeatureConfig> = {
    [EmeaFeature.INSTRUMENT_DELIVERY]: {
        countries: [Country.AT],
        roles: [],
        internalOnly: true
    },
    [EmeaFeature.PURCHASE_ORDER]: {
        countries: [Country.AT, Country.NL],
        roles: [],
        internalOnly: true
    },
    [EmeaFeature.ESKER]: {
        countries: [Country.CZ, Country.PL, Country.NL, Country.AT],
        roles: []
    },
    [EmeaFeature.ADMIN_AREA]: {
        roles: COUNTRY_ADMIN
    },
    [EmeaFeature.USER_MANAGEMENT]: {
        roles: COUNTRY_ADMIN
    },
    [EmeaFeature.TEAM_MANAGEMENT]: {
        roles: COUNTRY_ADMIN
    },
    [EmeaFeature.REQUEST_TYPE_MANAGEMENT]: {
        roles: ZONE_ADMIN
    },
    [EmeaFeature.TRANSLATION_MANAGEMENT]: {
        roles: ZONE_ADMIN
    },
    [EmeaFeature.RULE_SET_MANAGEMENT]: {
        roles: ADMIN
    },
    [EmeaFeature.PRIORITY_MANAGEMENT]: {
        roles: COUNTRY_ADMIN
    },
    [EmeaFeature.OUT_OF_OFFICE]: {
        roles: [Roles.TASK_OWNER]
    },
    [EmeaFeature.OUT_OF_OFFICE_CALENDAR]: {
        roles: TASK_OWNER_AND_ABOVE
    },
    [EmeaFeature.COUNTRY_SWITCHER]: {
        roles: [Roles.TASK_OWNER, Roles.ZONE_E_COMMERCE_STEWARD]
    }
};
